export const userRoles = {
    frontdesk: "FrontDesk",
    admin: "Admin",
    qa: "QualityInspector",
    dispatcher: "Dispatcher",
    superAdmin: "SuperAdmin",
    dataProcess: "DataProcess",
    customer: "customer"
}